<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pt-9 text-sm">
        <div class="flex items-center space-x-3 text-xs"></div>
        <div class="flex items-center space-x-3 text-xs"></div>
        <div class="flex items-center space-x-3">
            <span 
                class="material-icons text-black text-opacity-50 cursor-pointer text-2xl"
                matTooltip="Refresh"
                matTooltipClass="custom-orange-tooltip"
                matTooltipPosition="left"
                (click)="refresh()">
                refresh
            </span>
            <app-print-button       
                matTooltip="Export to Excel" 
                matTooltipPosition="left" 
                matTooltipClass="custom-orange-tooltip"
                (click)="print()" 
            >
            </app-print-button>
        </div>
    </div>

    <div class="w-700-px mx-auto">
        <form [formGroup]="announcementForm">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 space-y-5">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-60-px font-semibold">
                            URL:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" type="text" placeholder="URL" formControlName="webViewUrl">
                    </div>
                    <div class="card-input flex items-start text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">
                            Description:
                        </span>
                        <textarea formControlName="description" class="placeholder-black focus:outline-none w-full h-70-px bg-gray-100 rounded-md pl-3 resize-none italic" placeholder="Description (optional)" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                    <div class="flex flex-col items-start text-xs pl-5 mb-3">
                        <div class="flex items-center space-x-3 font-semibold">
                            <span>Cover Image: </span>
                            <input formControlName="image" type='file' accept="image/*" class="hidden" (change)="onSelectFile($event)" #coverImg>
                            <button type="button" class="browse-btn px-4 py-2 focus:outline-none" (click)="coverImg.click()">
                                Browse...
                            </button>
                        </div>
                        <div class="w-full flex justify-center">
                            <div class="w-200-px h-200-px border border-gray-300 rounded-md mt-3 flex items-center justify-center overflow-hidden bg-gray-50" *ngIf="img">
                                <img [src]="img" class="block w-full h-full object-contain">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input
                            class="w-full"
                            label="Date From:"
                            [parentForm]="announcementForm"
                            controlName="dateFrom">
                        </app-date-input>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input
                            class="w-full"
                            label="Date To:"
                            [parentForm]="announcementForm"
                            controlName="dateTo">
                        </app-date-input>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="w-full flex items-center justify-center mt-6 mb-4">
        <button (click)="store()" class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
            Submit
        </button>
    </div>

    <!-- Table Controls Component -->
    <app-table-controls
        #tableControls
        [currentLimit]="size"
        [searchPlaceholder]="'Search announcements'"
        (limitChangeEvent)="onLimitChangeFromComponent($event)"
        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
        (keydownEvent)="keyDownFunction($event)"
    ></app-table-controls>

    <!-- Data Table Component -->
    <app-data-table
        [tableHeader]="tableHeader"
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
    >
        <tr class="focus:outline-none" *ngFor="let announcements of announcement_lists">
            <td class="text-center">{{ announcements.webViewUrl | nullWithDefault }}</td>
            <td class="text-center">{{ announcements.description | nullWithDefault }}</td>
            <td class="text-center">{{ announcements.dateFrom | date:'yyyy-MM-dd' | nullWithDefault }}</td>
            <td class="text-center">{{ announcements.dateTo | date:'yyyy-MM-dd' | nullWithDefault }}</td>
            <td class="text-center">{{ announcements.viewers || 0  }}</td>
            <td class="text-center">
                <div class="flex justify-center">
                    <a [href]="announcements.imageUrl" *ngIf="announcements.imageUrl">
                        <img [src]="announcements.imageUrl" style="width:100px" alt="Announcement image">
                    </a>
                    <span *ngIf="!announcements.imageUrl">N/A</span>
                </div>
            </td>
            <td class="text-xs">
                <div class="flex items-center justify-center gap-2">
                    <ng-container *ngIf="announcements">
                        <button class="power-btn2 active" *ngIf="announcements.status === 0" (click)="disable(announcements.uid, 1)">
                            Enabled
                        </button>
                        <button class="power-btn2" *ngIf="announcements.status === 1" (click)="enable(announcements.uid, 0)">
                            Disabled
                        </button>
                    </ng-container>
                    <button class="action-btn-blue2 custom-btn" [routerLink]="['/features/announcement/announcement-edit/'+announcements.uid]">
                        Edit
                    </button>
                </div>
            </td>
        </tr>
    </app-data-table>

    <!-- Pagination Component -->
    <app-pagination
        [currentPage]="current_page"
        [totalPages]="total_pages"
        [pageSize]="size"
        [totalItems]="total"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        [showTotalEntries]="true"
    ></app-pagination>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>